import PulseLoader from "react-spinners/PulseLoader";
import tailwindTheme from "@/styles/tailwind.theme";

const LoadingTimeline = ({ className = "" }: { className?: string }) => {
  const colors = tailwindTheme.theme.colors;

  return (
    <div
      className={`flex h-full w-full items-center justify-center ${className}`}
    >
      <div className="rotate-90 transform">
        <PulseLoader color={colors.blue[500]} size={6} />
      </div>
    </div>
  );
};

export default LoadingTimeline;
